import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	documents: [],
	videos: [],
	webinars: [],
	faqs: [],
};

// active account slice
export const allShareholderRightsSlice = createSlice({
	name: 'shareholderRights',
	initialState,
	reducers: {
		setAllDocuments: (state, action) => {
			state.documents = action.payload;
		},
		setAllVideos: (state, action) => {
			state.videos = action.payload;
		},
		setAllWebinars: (state, action) => {
			state.webinars = action.payload;
		},
		setAllFaqs: (state, action) => {
			state.faqs = action.payload;
		},
	},
});

export const {
	setAllDocuments,
	setAllVideos,
	setAllWebinars,
	setAllFaqs,
} = allShareholderRightsSlice.actions;

export default allShareholderRightsSlice.reducer;
